import { useLDClient } from "launchdarkly-react-client-sdk";
import { useAmILoggedIn } from "modules/api-docs";
import { useEffect } from "react";

export const LaunchDarklyClientIdentifier = (props) => {
  const amILoggedInRes = useAmILoggedIn();
  const ldClient = useLDClient();
  useEffect(() => {
    if (!amILoggedInRes?.data) {
      return;
    }

    ldClient?.identify({
      key: "flo_nextJS",
      email: amILoggedInRes?.data?.email,
      custom: {
        orgId: amILoggedInRes?.data?.oid,
      },
    });
  }, [amILoggedInRes?.data, ldClient]);

  return props.children;
};
